import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsx } from 'react/jsx-runtime';

var MinusSmallIcon = ZepIcon_default((props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: /* @__PURE__ */ jsx(
  "rect",
  {
    x: 7,
    y: 11,
    width: 10,
    height: 2,
    rx: 1,
    fill: props.fill || "currentColor"
  }
) }));

export { MinusSmallIcon };
